import React from "react";
import { useTranslation } from "next-i18next";
import { IKeyFiguresData } from "src/api/server/extended-search.types";
import { useSearchStore } from "src/components/pages/search/store/search-store";
import { PopperWrapper } from "../popover/popper-wrapper";
import { KeyFiguresFilterBodyContent } from "./key-figures-filter-body-content";

const KEY_FIGURES_POPOVER_BODY_TEST_ID = "key-figures-popover-body";

interface IKeyFiguresPopover {
    keyFiguresData: IKeyFiguresData;
}

export const KeyFiguresPopover = ({ keyFiguresData }: IKeyFiguresPopover) => {
    const { t } = useTranslation("extended-search");

    const { keyFigures: selectedKeyFigures } = useSearchStore();
    const totalNumberOfKeyFigures = keyFiguresData.keyFiguresGroups.reduce((acc, keyFiguresGroup) => acc + keyFiguresGroup.keyFigures.length, 0);

    return (
        <PopperWrapper
            bodyTestId={KEY_FIGURES_POPOVER_BODY_TEST_ID}
            id={t("key-figures")}
            buttonProps={{
                title: t("key-figures"),
                badgeInfo: `${selectedKeyFigures.length} / ${totalNumberOfKeyFigures}`,
            }}
            popperSx={{
                zIndex: 1,
                width: { xs: "100%", sm: "100%", md: "810px" },
                px: { xs: 1, sm: 1, md: 0 },
            }}
            boxSx={{
                p: 0,
            }}
        >
            <KeyFiguresFilterBodyContent keyFiguresData={keyFiguresData} />
        </PopperWrapper>
    );
};
